import { render, staticRenderFns } from "./CollectionsPage.vue?vue&type=template&id=a1da83ec"
import script from "./CollectionsPage.vue?vue&type=script&lang=js"
export * from "./CollectionsPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports